import { Link } from "react-router-dom";
import { wedding } from "@/lib/weddingData";
import HandHeart from "./HandHeart";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#c9c3b3] bg-[#ECE7DC] py-20 md:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]">Save the Date</p>
          <p className="corner-label text-[#8a8580]">© {new Date().getFullYear()}</p>
        </div>

        <div className="mt-16 relative">
          <HandHeart
            variant={3}
            size={46}
            rotate={-18}
            className="absolute -right-2 -top-6 hidden md:block"
          />
          <h2 className="hero-script">
            Macarena & Virginia
          </h2>
        </div>

        <div className="mt-16 border-t border-[#c9c3b3] pt-8">
          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-12 md:col-span-3">
              <p className="corner-label text-[#8a8580]">La fecha</p>
              <p className="mt-2 corner-label">04 · 06 · 2027</p>
            </div>
            <div className="col-span-12 md:col-span-4">
              <p className="corner-label text-[#8a8580]">El lugar</p>
              <p className="mt-2 corner-label">
                Cortijo de Enmedio
                <br />
                Granada, España
              </p>
            </div>
            <div className="col-span-12 md:col-span-5 md:text-right">
              <p className="corner-label text-[#8a8580]">Índice</p>
              <div className="mt-2 flex flex-wrap gap-x-2 md:justify-end">
                <a href="#date" className="corner-label nav-underline">Fecha</a>
                <span className="corner-label text-[#8a8580]">,</span>
                <a href="#location" className="corner-label nav-underline">Lugar</a>
                <span className="corner-label text-[#8a8580]">,</span>
                <Link
                  to="/logistica"
                  onClick={() => window.scrollTo(0, 0)}
                  className="corner-label nav-underline"
                >
                  Granada
                </Link>
                <span className="corner-label text-[#8a8580]">,</span>
                <a href="#rsvp" className="corner-label nav-underline">RSVP</a>
                <span className="corner-label text-[#8a8580]">,</span>
                <a href="#faq" className="corner-label nav-underline">FAQ</a>
                <span className="corner-label text-[#8a8580]">,</span>
                <a href="#gifts" className="corner-label nav-underline">Regalos</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
